import React from "react";
import './css/HeadStyle.css';
import { Link } from "react-router-dom";

function HeaderTop() {
    return (
        <div className="headertop py-2">
            <div className="container">
                <div className="row text-white">
                    <div className="col-md-6 d-flex align-items-center gap-4 text-white">
                        <Link to="#" className="text-decoration-none text-white">
                            <i className="bi bi-telephone"></i> +91-9717270400
                        </Link>
                        <Link to="mailto:info@vigyanvriksh.in" className="text-white text-decoration-none d-flex align-items-center">
                            <i className="bi bi-envelope-at me-1"></i> info@vigyanvriksh.in
                        </Link>
                    </div>
                    <div className="col-md-6 d-flex justify-content-md-end align-items-center gap-4 text-white">
                        <div>
                            <Link className="text-white" to="https://www.google.com/maps/dir//H,+1449,+Outram+Ln,+GTB+Nagar,+Delhi,+110009/@28.704283,77.1280926,27826m/data=!3m1!1e3!4m8!4m7!1m0!1m5!1m1!1s0x390cfdde3d2dee83:0x88abdb2639ea7060!2m2!1d77.210494!2d28.704308?entry=ttu&g_ep=EgoyMDI1MDkwNy4wIKXMDSoASAFQAw%3D%3D" target="_blank"><i className="bi bi-pin-map me-1"></i> Outram lane, GTB nagar, New Delhi, 110009</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HeaderTop;